import * as React from 'react'
import { compose, pure } from 'recompose'

import LargeTitle, { SizeType } from '../../atoms/LargeTitle/LargeTitle'
import Progressbar from '../../atoms/Progressbar/Progressbar'
import * as styles from './QuestionTitle.css'

interface QuestionTitleProps {
  title: string
  time?: number
  limit_time: number
}

const QuestionTitle: React.FunctionComponent<QuestionTitleProps> = ({ title, limit_time, time }) => (
  <div>
    <div className={styles.title}>
      <LargeTitle size={SizeType.TINY}>{title}</LargeTitle>
    </div>
    <div className={styles.bar}>
      <Progressbar max={limit_time} now={time === undefined ? limit_time : time} />
    </div>
  </div>
)

export default compose<QuestionTitleProps, QuestionTitleProps>(pure)(QuestionTitle)
